(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (document.body.dataset.fioriMotion === 'false' || reduced.matches || !('IntersectionObserver' in window) || window.Shopify?.designMode) return;
  const seen = new WeakSet();
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      if (!reduced.matches) entry.target.classList.add('fiori-gentle-reveal');
    }
  }, {threshold: .08});
  function initialize() {
    // Only below-the-fold editorial content; product media/forms remain immediate.
    document.querySelectorAll('.fiori-home #MainContent > .shopify-section, .fiori-contact-welcome__inner, .fiori-page-page .fiori-story, .fiori-page-page .fiori-about-gallery').forEach(el => {
      if (seen.has(el)) return;
      seen.add(el);
      if (el.getBoundingClientRect().top >= window.innerHeight) observer.observe(el);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  reduced.addEventListener('change', () => {
    if (reduced.matches) { observer.disconnect(); document.querySelectorAll('.fiori-gentle-reveal').forEach(el => el.classList.remove('fiori-gentle-reveal')); }
  });
})();
